import { ETransactionStatus } from "../odo/ITransactionEvent";
import { TransactionStatus } from "./TransactionStatus";

export const odoStatusToTransactionStatusMap: Record<
  ETransactionStatus,
  TransactionStatus
> = {
  [ETransactionStatus.CANCELED]: TransactionStatus.Canceled,
  [ETransactionStatus.CREATED_BY_BANK]: TransactionStatus.Processing,
  [ETransactionStatus.CREATED_BY_ZEAL]: TransactionStatus.Processing,
  [ETransactionStatus.PENDING]: TransactionStatus.Processing,
  [ETransactionStatus.PROCESSING]: TransactionStatus.Processing,
  [ETransactionStatus.ERROR]: TransactionStatus.Returned,
  [ETransactionStatus.RETURNED]: TransactionStatus.Returned,
  [ETransactionStatus.SETTLED]: TransactionStatus.Settled,
  [ETransactionStatus.SENT]: TransactionStatus.Processing,
} as const;
